const SITE_URL = 'https://ninjou.fi'

export function absoluteUrl(path) {
  if (!path || path === '/') {
    return `${SITE_URL}/`
  }
  const normalized = path.startsWith('/') ? path : `/${path}`
  const withSlash = normalized.endsWith('/') ? normalized : `${normalized}/`
  return `${SITE_URL}${withSlash}`
}

export function buildAlternates(entries) {
  const alternates = {}
  Object.entries(entries).forEach(([lang, path]) => {
    if (path) {
      alternates[lang] = absoluteUrl(path)
    }
  })
  return alternates
}

export function blogPostPath(locale, slug) {
  const prefix = locale === 'fi' ? '' : `${locale}/`
  return `${prefix}blog/${slug}`
}

export function basicPagePath(locale, slug) {
  const prefix = locale === 'fi' ? '' : `${locale}/`
  return `${prefix}${slug}`
}

export function landingPagePath(locale, slug, isFrontPage) {
  if (isFrontPage) {
    return locale === 'fi' ? '/' : `${locale}`
  }
  return locale === 'fi' ? slug : `${locale}/${slug}`
}

/** Build FI/EN hreflang pairs from the current blog listing pathname. */
export function buildBlogListingAlternates(pathname) {
  const fiMatch = pathname.match(/^\/blog(?:\/(\d+))?\/?$/)
  if (fiMatch) {
    const page = fiMatch[1] ? `/${fiMatch[1]}` : ''
    return buildAlternates({
      fi: `blog${page}`,
      en: `en/blog${page}`,
    })
  }
  const enMatch = pathname.match(/^\/en\/blog(?:\/(\d+))?\/?$/)
  if (enMatch) {
    const page = enMatch[1] ? `/${enMatch[1]}` : ''
    return buildAlternates({
      fi: `blog${page}`,
      en: `en/blog${page}`,
    })
  }
  return undefined
}

export function resolveLocalized(value, language) {
  if (!value) {
    return undefined
  }
  if (typeof value === 'string') {
    return value
  }
  return value[language] || value.fi || value.en
}

export function buildSanityImageUrl(source) {
  if (!source?.asset) {
    return undefined
  }
  try {
    const { imageUrlFor } = require('./image-url')
    return imageUrlFor(source).width(1200).height(630).fit('crop').url()
  } catch {
    return undefined
  }
}

export function toAbsoluteAssetUrl(url) {
  if (!url) {
    return undefined
  }
  if (url.startsWith('http')) {
    return url
  }
  return `${SITE_URL}${url.startsWith('/') ? url : `/${url}`}`
}

export const ORGANIZATION = {
  name: 'Ninjou Oy',
  legalName: 'Ninjou Oy',
  url: SITE_URL,
  logo: `${SITE_URL}/icons/icon.png`,
  telephone: '+358456790809',
  email: 'admin@ninjou.fi',
  address: {
    streetAddress: 'Lehtissaarentie 11',
    addressLocality: 'Säynätsalo',
    postalCode: '40900',
    addressCountry: 'FI',
  },
  sameAs: ['https://laskutus.ninjou.fi'],
}
